import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=418af164&scoped=true&lang=html&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418af164",
  null
  
)

export default component.exports